import { NgModule } from '@angular/core';
import { CoreModule } from '@app/core/core.module';
import { WorkComponent } from '@app/work/pages/work/work.component';
import { WorkRoutingModule } from '@app/work/work-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { StoreModule } from '@ngrx/store';
import { stateKey, workReducers } from '@app/work/store/work.slice';
import { WorkProgressBarComponent } from '@app/work/components/work-progress-bar/work-progress-bar.component';
import { WorkWeekOverviewComponent } from '@app/work/components/work-week-overview/work-week-overview.component';
import { WorkedHoursAndPaymentsComponent } from './components/worked-hours-and-payments/worked-hours-and-payments.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MaskitoDirective } from '@maskito/angular';
import { TimeInputComponent } from '@app/form-controls/time-input/time-input.component';
import { ListButtonComponent } from '@app/shared/ui/list-button/list-button.component';
import { ButtonComponent } from '@app/shared/ui/button/button.component';
import { PageHeaderComponent } from '@app/shared/ui/page-header/page-header.component';
import { CondensedHeaderComponent } from '@app/shared/ui/condensed-header/condensed-header.component';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    IonicModule,
    WorkRoutingModule,
    StoreModule.forFeature(stateKey, workReducers),
    TranslocoPipe,
    MaskitoDirective,
    TimeInputComponent,
    ListButtonComponent,
    PageHeaderComponent,
    CondensedHeaderComponent,
    ButtonComponent,
  ],
  declarations: [
    WorkComponent,
    WorkProgressBarComponent,
    WorkWeekOverviewComponent,
    WorkedHoursAndPaymentsComponent,
  ],
})
export class WorkModule {}
